import { render, staticRenderFns } from "./BotRepresentatives.vue?vue&type=template&id=0a35ee07"
import script from "./BotRepresentatives.vue?vue&type=script&lang=js"
export * from "./BotRepresentatives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports